export type SessionType = 'scenario' | 'esperienza';
export const StepType = {
  QUESTION: 'QUESTION',
  VIDEO: 'VIDEO',
} as const;

export type StepQuestionType = {
  id: string;
  type: typeof StepType.QUESTION;
  name?: string;
  text: string;
  answers: Array<{ id: string; label: string; goToStepId: string }>;
  order: number;
};

export type StepVideoType = {
  id: string;
  type: typeof StepType.VIDEO;
  name?: string;
  videoId: string;
  audioId?: string;
  order: number;
};
